export enum LoginAppPathsEnum {
	COMPLETEPROFILE = '/CompleteProfile'
}
